import { render } from "./Shoprent.vue?vue&type=template&id=1234fd01&scoped=true"
import script from "./Shoprent.vue?vue&type=script&lang=js"
export * from "./Shoprent.vue?vue&type=script&lang=js"

import "./Shoprent.vue?vue&type=style&index=0&id=1234fd01&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1234fd01"]])

export default __exports__